<button class="linklike" id="back">&larr; Retour</button>
<div class="artistHero">
  <img class="artistHeroPhoto" id="artistPhoto" alt="" loading="lazy" onerror="this.classList.add('noImage')" />
  <div class="artistHeroInfo">
    <span class="heroKicker">Artiste</span>
    <h1></h1>
    <span class="hint" id="albumCount"></span>
    <div class="heroActions">
      <button id="launchBtn" class="heroPlayBtn"><span class="heroPlayIcon" id="launchBtnIcon"></span><span id="launchBtnLabel">Écouter toute la discographie</span></button>
    </div>
  </div>
</div>
<input id="searchInput" class="searchBar" type="search" placeholder="Rechercher un album..." />
<p class="hint searchEmpty hide">Aucun résultat.</p>
<div id="grid" class="grid"></div>
